import axiosInstance from "../axios";

export const getUsers = () => {
  return axiosInstance.get("/users");
};

export const createUser = (userData) => {
  return axiosInstance.post("/users", userData);
};

export const updateUser = (id, userData) => {
  return axiosInstance.put(`/users/${id}`, userData);
};

export const resetUserPassword = (id) => {
  return axiosInstance.post(`/users/${id}/reset_password`);
};